import { connect } from "react-redux";
import { change_user_filter } from "../users/actions";

function mapStateToProps(state) {
  return {
    users: state.users,
    invoices: state.invoices.invoices,
    transactions: state.transactions,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    changeUserFilter: (event) => {
      const value = event.target.value.replace(/ /g, "");
      dispatch(change_user_filter(value));
    },
    logout: () => {
      localStorage.removeItem("admin.usr");
      window.location.reload();
    },
  };
}

export const homeConnector = connect(mapStateToProps, mapDispatchToProps);
